import api from "@/services/api";

export default {
  getList(params) {
    return api.get('/report/approved-supplier', { params });
  },
  exportExcel(params) {
    return api.get('/report/approved-supplier/export-excel', {
      params,
      responseType: 'blob',
    });
  },
};
